var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88 1.86436V43.9113C88 67.7093 68.6876 87 44.8873 87C44.2619 87 43.6584 86.989 43.0439 86.9561C43.011 86.353 43 85.7388 43 85.1356V43.0887C43 19.2907 62.3014 0 86.1127 0C86.7381 0 87.3416 0.0109668 87.9561 0.0438674C87.989 0.647044 88 1.26119 88 1.86436Z",
    fill: "#86AA57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40 72.5389V87C17.5951 85.1534 0 66.354 0 43.4499V29C10.5971 29.8565 20.1277 34.5397 27.2147 41.6256C35.1125 49.5458 39.9889 60.4806 39.9889 72.5389H40Z",
    fill: "#6A7C43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollower);
export default __webpack_public_path__ + "static/media/follower.beadc9f3716bd61a92541bc5310ca662.svg";
export { ForwardRef as ReactComponent };